<template>
    <div class="mt-8">
        <div class="mx-auto px-4 sm:px-6 lg:px-8">
            <div class="mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3">
                <component
                    :is="widget.name"
                    v-for="(widget, index) in elements"
                    :widget="widget"
                    :key="`${widget.name}_${index}`"
                />
            </div>
        </div>
    </div>
</template>
<script>
import InspiringQuoteWidget from '@/components/Widgets/Teacher/InspiringQuoteWidget.vue';
import LatestActivityResponsesWidget from '@/components/Widgets/Teacher/LatestActivityResponsesWidget.vue';
import BestAndWorstSubjectsWidget from '@/components/Widgets/Teacher/BestAndWorstSubjectsWidget.vue';
import GamificationCardWidget from '@/components/Widgets/Teacher/GamificationCardWidget.vue';
import SparklineGraphWidget from '@/components/Widgets/Teacher/SparklineGraphWidget.vue';
import BattlesWidget from '@/components/Widgets/Student/BattlesWidget.vue';
import ChestWidget from '@/components/Widgets/Student/ChestWidget.vue';
import CurrencyPointsWidget from '@/components/Widgets/Student/CurrencyPointsWidget.vue';
import MoodCheckWidget from '@/components/Widgets/Student/MoodCheckWidget.vue';
import SelfAttendanceStudentWidget from '@/components/Widgets/Student/SelfAttendanceStudentWidget.vue';
import SchoolOnboardingWidget from '@/components/Widgets/Admin/SchoolOnboardingWidget.vue';
import SingleButtonWidget from '@/components/Widgets/Student/SingleButtonWidget.vue';
import QuestsWidget from '@/components/Widgets/Student/QuestsWidget.vue';
import CalendarChartWidget from '@/components/Widgets/Teacher/CalendarChartWidget.vue';
import BasicWidget from './Widgets/Teacher/BasicWidget.vue';
import MultipleButtonsWidget from '@/components/Widgets/Student/MultipleButtonsWidget.vue';
import FactionWidget from './Widgets/Student/FactionWidget.vue';

export default {
    name: 'DashboardStudentWidgets',
    components: {
        'basic-widget': BasicWidget,
        'self-attendance': SelfAttendanceStudentWidget,
        'mood-check-widget': MoodCheckWidget,
        'quote-widget': InspiringQuoteWidget,
        'sociogram-survey': SingleButtonWidget,
        'available-surveys': MultipleButtonsWidget,
        'latest-activity-responses': LatestActivityResponsesWidget,
        'best-worst-subjects': BestAndWorstSubjectsWidget,
        'gamification-card-widget': GamificationCardWidget,
        'sparkline-graph': SparklineGraphWidget,
        'battles-widget': BattlesWidget,
        'chest-widget': ChestWidget,
        'latest-currency-points-widget': CurrencyPointsWidget,
        'student-onboarding': SchoolOnboardingWidget,
        'quests-widget': QuestsWidget,
        'calendar-graph': CalendarChartWidget,
        'faction-widget': FactionWidget,
    },
    props: ['widgets'],
    data() {
        return {
            elements: JSON.parse(JSON.stringify(this.widgets)),
        };
    },
};
</script>
